import { useCityStore } from "./list";
import { useUserStore } from "./user";
import { useAlertsStore } from "./print";
import { usePaymentStore } from "./payment";
export default function usePiniaStore() {
  return {
    cityListStore: useCityStore(),
    userStore: useUserStore(),
    printStore: useAlertsStore(),
    paymentStore: usePaymentStore(),
  };
}
